import { useAppState } from "@hooks/index"
import { userMenuList, adminMenuList, finapiMenuList } from "./utils"

const filterFn = (obj: any, role: string) => {
  const filtered = obj.submenus.filter((submenu: any) =>
    submenu.roles.includes(role)
  )
  return { ...obj, submenus: filtered }
}

const filterUserMenuList = (obj: any, role: string) => {
  const filtered = obj.map((selected: any) => {
    const submenus = selected.submenus.filter(
      (submenu: any) => submenu?.enabled !== false && role === "user"
    )

    return { ...selected, submenus }
  })
  return filtered
}

const useGetMenuList = () => {
  const { global } = useAppState()

  const role = global.user?.role || "user"
  let list

  if (role === "admin" || role === "processor") {
    list = {
      menuList: userMenuList,
      adminMenuList: filterFn(adminMenuList, role),
    }
  } else if (role === "finapi") {
    list = { menuList: finapiMenuList }
  } else {
    list = { menuList: filterUserMenuList(userMenuList, role) }
  }

  return list
}

export default useGetMenuList
